import React, { useContext } from 'react';
import { ArrowLink, GridColumn, GridWrapper, GridRow, Buttons, Button, Text, Heading } from 'react-onei';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { events } from '../conf/tags_ga.conf';
import TagService from '../services/TagService';
import UserContext from '../context/UserContext';

function DefaultContactPage() {
  let history = useHistory();
  const { contacts, setStep, wording } = useContext(UserContext);
  const {
    WLOST_200,
    WLOST_290,
    WLOST_291,
    WLOST_292,
  } = wording;
  const defaultContact = contacts.find(contact => contact.isDefault);
  const message = WLOST_290.replace('{defaultContact}', defaultContact.contactView);

  function handleClick() {
    // Send OTC
    TagService.sendEvent(events.defaultContactOtcSms);
    setStep('/otc');
    history.push({
      pathname: '/otc',
      state: { contact: defaultContact },
    })
  }

  function handleBackToChoice() {
    TagService.sendEvent(events.defaultContactListLink);
    setStep('/choice');
  }

  if (!defaultContact) {
    return null;
  }

  return (
    <GridWrapper>
      <GridRow>
        <GridColumn>
          <Heading as="h3" id="default-contact-title" className="spacing-m">
            {WLOST_200}
          </Heading>
          <Text id="default-contact-message" className="spacing-xs">
            {message}
          </Text>
          <Buttons direction="vertical">
            <Button className="spacing-s" id="otc-button" onClick={handleClick}>{WLOST_291}</Button>
            <ArrowLink
              href=""
              as={Link}
              to="/choice"
              id="contact-list-link"
              aria-label={WLOST_292}
              title={WLOST_292}
              variant="previous"
              fullWidth
              className="spacing-s"
              onClick={handleBackToChoice}
            >
              {WLOST_292}
            </ArrowLink>
          </Buttons>
        </GridColumn>
      </GridRow>
    </GridWrapper>
  )
}

export default DefaultContactPage;